---
fr:
  overview_map:
    homepage: Site internet
    nearest: centrale la plus proche
    news: Actualité
    nve_concession: Concession NVE
